// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Duplicate = function Duplicate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#duplicate-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5 18.125h8.75a.627.627 0 0 0 .625-.625V15h1.875v2.5c0 1.379-1.121 2.5-2.5 2.5H2.5A2.5 2.5 0 0 1 0 17.5V8.75c0-1.379 1.121-2.5 2.5-2.5H5v1.875H2.5a.627.627 0 0 0-.625.625v8.75c0 .344.281.625.625.625m6.25-6.25h8.75a.627.627 0 0 0 .625-.625V2.5a.627.627 0 0 0-.625-.625H8.75a.627.627 0 0 0-.625.625v8.75c0 .344.281.625.625.625m-2.5-.625V2.5c0-1.379 1.121-2.5 2.5-2.5h8.75C18.879 0 20 1.121 20 2.5v8.75c0 1.379-1.121 2.5-2.5 2.5H8.75a2.5 2.5 0 0 1-2.5-2.5"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "duplicate-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
